import {
  Alert,
  Button,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { theme } from '../../styles/Theme';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import mainLogo from '../../assets/e1logo.svg';
import axios from 'axios';
import Cookies from 'js-cookie';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import Result from './components/Result';
import affinity_logo from '../../assets/affinity_logo.png';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
const classes = {
  page: {
    width: '100%',
    overflow: 'auto',
  },

  bold: {
    fontWeight: 'bold',
  },
  textAlign: {
    display: 'flex',
    justifyContent: 'center',
  },
  logoWrapper: {
    paddingLeft: '2%',
    paddingRight: '2%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  loadingAnimationContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialog: {
    [theme.breakpoints.down('sm')]: {
      borderRadius: '10px 10px 0 0',
      height: 'min-content',
      alignSelf: 'end',
    },
    padding: '15px',
  },
  form_wrapper: {
    width: '50%',
    mb: '15px',
    [theme.breakpoints.down('md')]: {
      width: '90%',
      margin: '0 auto',

    },
    overflowY: 'auto',
  },

  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  contentInside: {
    maxWidth: '420px',
    width: '100%',
},

};

const ResultsPage = () => {
  const mobile = useMediaQuery(theme.breakpoints.down('xs'));
  const mobileMid = useMediaQuery(theme.breakpoints.down('sm'));
  let navigate = useNavigate();
  const location = useLocation();
  const [affinityModal, setAffinityModal] = useState(false);
  const [modalTextInput, setModalTextInput] = useState('');
  const client_id = Cookies.get('access_token');
  const [affinityError, setAffinityError] = useState(null);

  const resultData = location.state?.resultData || null;
  const [warningError, setWarningError] = useState(() => {
    if (resultData?.warning) {
      setTimeout(() => setWarningError(null), 10000);
      return resultData.warning;
    }
    return null;
  });

  const handleBack = async () => {
    const response = await axios.get(`/api/delete/${client_id}`);
    window.location.href = '/';
  };

  const logoutResults = () => {
    console.log("LOG OUT");
    axios
      .post('/api/logout', {
        headers: {
          Authorization: ``,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        Cookies.remove('access_token');
        window.location.href = '/';

      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={resultData ? {height: '100vh' } : {}}
      sx={classes.page}
      >
        <Grid item xs={12} sx={classes.logoWrapper}>
          <img
            src={mainLogo}
            alt='logo'
            style={{
              width: mobile ? '5rem' : '15rem',
              height: mobile ? '3rem' : '10rem',
              fill: 'white',
            }}
          />
          <Button
            variant='outlined'
            sx={{ border: '1px solid white', color: 'white' }}
            onClick={() => logoutResults()}
            startIcon={<LogoutOutlinedIcon sx={{ color: 'white' }} />}
          >
            Logout
          </Button>
        </Grid>
        <Grid item sx={{ width: '100%', ml: '2%', alignItems: 'start' }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => handleBack()}
            sx={{ color: 'white' }}
          >
            Score another company
          </Button>
        </Grid>
        {warningError && (
    <Alert
        variant='filled'
        severity='warning'
        sx={{
            position: 'fixed',
            top: 10,
            left: 0,
            right: 0,
            zIndex: 9999,
            margin: '0 auto',
            width: '25%',
            borderRadius: '20px',
            backgroundColor: '#FEDD5',
            color: '#FEDD5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        <Typography>{warningError[0]}</Typography>
    </Alert>
)}
        {affinityError && (
          <Alert
            variant='filled'
            severity='warning'
            sx={{
              position: 'fixed',
              top: 10,
              left: 0,
              right: 0,
              zIndex: 9999,
              margin: '0 auto',
              width: '30%',
              borderRadius: '20px',
              backgroundColor: '#FEDD5',
              color: '#FEDD5',
            }}
          >
            <Typography>{affinityError}</Typography>
          </Alert>
        )}

<Grid
  item
  style={resultData != null ? { marginBottom: '150px' } : {}}
  sx={classes.form_wrapper}
>
  {resultData ? (
    <Result result={resultData} />
  ) : (
    <Grid item sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant='h5' sx={{ color: 'white', mb: 2 }}>
        No results available
      </Typography>
      <Button
        variant='outlined'
        sx={{ color: 'white', borderColor: 'white' }}
        onClick={() => navigate('/')}
      >
        Go to scoring form
      </Button>
    </Grid>
  )}
</Grid>

      </Grid>
    </>
  );
};

export default ResultsPage;
